const CHUNK_RELOAD_PREFIX = 'bizbuzz:chunk-reload:';

function getErrorMessage(error: unknown) {
  if (error instanceof Error) return error.message || '';
  if (typeof error === 'string') return error;
  return '';
}

function getErrorName(error: unknown) {
  return error instanceof Error ? error.name || '' : '';
}

export function isStaleChunkError(error: unknown) {
  const message = getErrorMessage(error);
  const name = getErrorName(error);

  return (
    name === 'ChunkLoadError' ||
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Importing a module script failed') ||
    message.includes('error loading dynamically imported module') ||
    message.includes('Loading chunk') ||
    message.includes('Failed to load module script')
  );
}

export function reloadOnceForStaleChunk(error: unknown) {
  if (typeof window === 'undefined' || !isStaleChunkError(error)) return false;

  const key = `${CHUNK_RELOAD_PREFIX}${window.location.pathname}`;
  const lastAttempt = Number(window.sessionStorage.getItem(key) || 0);
  const now = Date.now();

  // Retry once per path in a short window. If the new deployment still cannot
  // serve the chunk, let the normal error UI render instead of looping.
  if (now - lastAttempt < 30_000) return false;

  window.sessionStorage.setItem(key, String(now));
  window.location.reload();
  return true;
}
